import { SAVE_LOYALTY_RANK } from './../types/index';
import { LoyaltyRankResponse } from '../../dataType/loyalty';
export const saveLoyaltyRank = (payload: LoyaltyRankResponse[]) => ({
  type: SAVE_LOYALTY_RANK,
  payload
});